import { render, staticRenderFns } from "./TransactionListDetail.vue?vue&type=template&id=15a8a968&"
import script from "./TransactionListDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionListDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransactionListDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDivider,VLayout,VToolbar,VToolbarItems})
